export const PARTICIPANTS_CONSTANTS = {
  ROL_TYPE: {
    ALL: 'ALL',
    AMPHITRYON: 'HEALTH_PROFESSIONAL',
    AMPHITRYON_SHORT: 'H',
    USER: 'PATIENT',
    USER_SHORT: 'P'
  }
};
